import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { UtilService } from 'src/app/modules/shared/services/util.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private _router: Router,
    private _utilService: UtilService
  ) {}

  async canActivate(
    _activatedRouteSnapshot: ActivatedRouteSnapshot,
    _routerStateSnapshot: RouterStateSnapshot
  ) {
    const routeUrl: any = _routerStateSnapshot.url;
    const currentModule: any = _activatedRouteSnapshot.data.module;
    const menuCode: any = _activatedRouteSnapshot.data.menuCode;

    let loginStorageData: any;

    if (currentModule == 'retailer') { // Retailer login
      loginStorageData = await this._utilService.getStorageData('R_LOGIN');
    } else if (currentModule == 'cpg') { // CPG login
      loginStorageData = await this._utilService.getStorageData('C_LOGIN');
    } else if (currentModule == 'distributor') { // Distributor login
      loginStorageData = await this._utilService.getStorageData('D_LOGIN');
    } else if (currentModule == 'admin') { // Admin login
      loginStorageData = await this._utilService.getStorageData('A_LOGIN');
    }

    if (!loginStorageData) { // Login data not found
      this._utilService.showToast('Access denied', '', 'error', {});

      if (currentModule == 'retailer') { // Retailer login
        this._utilService.retailerLogout();
      } else if (currentModule == 'cpg') { // CPG login
        this._utilService.cpgLogout();
      } else if (currentModule == 'distributor') { // Distributor login
        this._utilService.distributorLogout();
      } else if (currentModule == 'admin') { // Admin login
        this._utilService.adminLogout();
      }
      return false;
    } else {
      if (loginStorageData.token && loginStorageData.menu.length > 0) { // Logged In
        let responseCheckUserAccess = await this._utilService.checkUserAccess(menuCode, loginStorageData.menu);
        
        if (responseCheckUserAccess) {
          return true;
        } else if (menuCode == 'R-ALL-USERS_ACCESS' || menuCode == 'C-ALL-USERS_ACCESS' || menuCode == 'D-ALL-USERS_ACCESS') { // Page accessible to all users of retailer/cpg/distributor 
          return true;
        } else { // Access denied
          this._utilService.showToast('Access denied', '', 'error', {});

          if (currentModule == 'retailer') { // Retailer login
            this._utilService.retailerLogout();
          } else if (currentModule == 'cpg') { // CPG login
            this._utilService.cpgLogout();
          } else if (currentModule == 'distributor') { // Distributor login
            this._utilService.distributorLogout();
          } else if (currentModule == 'admin') { // Admin login
            this._utilService.adminLogout();
          }
          return false;
        }
      } else { // Not Logged In
        this._utilService.showToast('Access denied', '', 'error', {});

        if (currentModule == 'retailer') { // Retailer login
          this._utilService.retailerLogout();
        } else if (currentModule == 'cpg') { // CPG login
          this._utilService.cpgLogout();
        } else if (currentModule == 'distributor') { // Distributor login
          this._utilService.distributorLogout();
        } else if (currentModule == 'admin') { // Admin login
          this._utilService.adminLogout();
        }
        return false;
      }
    }
  }

}
